import {ContentBlockEditPage} from "./ContentBlockEditPage";
import {apiGetForAjaxResponse} from "./lib/SecuredAjax";
import {AppConfig} from "./AppConfig";
import {toastFetchError} from "./lib/fetch";
import {EditorView} from "codemirror";

export class TimerEditPage {
	private readonly body: HTMLTextAreaElement;
	private readonly bodyView: EditorView;

	private bodyContentBlockLastCode = ""
	private bodyMemory = new Map<String, String>();

	constructor() {
		this.body = document.querySelector('textarea[name="body"]') as HTMLTextAreaElement;
		this.bodyView = ContentBlockEditPage.initEditor(this.body, 'javascript')!;
		ContentBlockEditPage.initEditor(document.querySelector('textarea[name="scriptParams"]') as HTMLTextAreaElement, 'json');

		const bodyContentBlockSelect = document.querySelector(`select[name="bodyContentBlock"]`) as HTMLSelectElement;

		this.bodyContentBlockLastCode = bodyContentBlockSelect.value;

		bodyContentBlockSelect.addEventListener('change', () => {
			this.bodyMemory.set(this.bodyContentBlockLastCode, this.bodyView.state.doc.toString());
			this.bodyContentBlockLastCode = bodyContentBlockSelect.value;

			const bodyContainer = this.body.closest('.cm-editor-form-control') as HTMLDivElement;
			bodyContainer.setAttribute("disabled", "disabled")
			bodyContainer.style.opacity = ".3";

			const getBodyCode = this.bodyContentBlockLastCode

			const getBodyCodeParams = new URLSearchParams();
			getBodyCodeParams.set("contentBlockCode", getBodyCode);
			const getBodyPromise: Promise<string | null> = getBodyCode
				? apiGetForAjaxResponse(`${AppConfig.CP}/op/getTimerBody?${getBodyCodeParams.toString()}`)
				: Promise.resolve(null)

			getBodyPromise
				.then(body => {
					if (this.bodyContentBlockLastCode === getBodyCode) {
						const newBody = (body === null || body === undefined) ? `${this.bodyMemory.get(getBodyCode)}` : body
						const editorState = this.bodyView.state;
						const transaction = editorState.update({changes: {from: 0, to: editorState.doc.length, insert: newBody}});
						this.bodyView.update([editorState.update(transaction)])
					}
				})
				.catch(toastFetchError)
				.finally(() => {
					if (this.bodyContentBlockLastCode == getBodyCode) {
						bodyContainer.removeAttribute("disabled")
						bodyContainer.style.opacity = "";
					}
				});
		});

		const typeSelect = document.querySelector(`select[name="type"]`) as HTMLSelectElement;
		typeSelect.addEventListener('change', () => this.displayFieldsForType(typeSelect.value))
		this.displayFieldsForType(typeSelect.value);
	}

	private displayFieldsForType(type: string) {
		const knownTypes = ['TIMER_ONE', 'TIMER_PERIODIC', 'TIMER_SCHEDULED'];
		const conditionalNodes = Array.from(document.querySelectorAll(`[data-timerType-only]`)) as HTMLElement[];

		function isNodeForType(node: HTMLElement) {
			const timeTypeOnly = node.getAttribute('data-timerType-only')
			if (!timeTypeOnly) return false;
			return timeTypeOnly.split(/[, ]/).findIndex(part => part == type) >= 0;
		}

		knownTypes
			.filter(known => known != type)
			.forEach(known => {
				conditionalNodes
					.filter(node => !isNodeForType(node))
					.forEach(node => node.setAttribute("hidden", "hidden"))
			});

		conditionalNodes
			.filter(node => isNodeForType(node))
			.forEach(node => node.removeAttribute("hidden"));
	}
}